var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { ApplicationContext } from '../../../../ApplicationContext';
/**
 *
 */
var MapStyleToggle = /** @class */ (function (_super) {
    __extends(MapStyleToggle, _super);
    /**
     *
     */
    function MapStyleToggle(props) {
        var _this = _super.call(this, props) || this;
        _this.options = ['grayscale_dark', 'satellite_road_labels', 'road'];
        _this.state = { mapStyle: 'satellite_road_labels' };
        _this.onToggle = _this.onToggle.bind(_this);
        _this.onSelect = _this.onSelect.bind(_this);
        return _this;
    }
    /**
     *
     */
    MapStyleToggle.prototype.componentDidMount = function () {
    };
    /**
     *
     * @returns {*}
     */
    MapStyleToggle.prototype.render = function () {
        var _this = this;
        var session = this.context.session;
        var _a = this.state, expanded = _a.expanded, mapStyle = _a.mapStyle;
        if (!session.isLoggedIn) {
            return null;
        }
        var classes = classNames({
            "map-style-toggle p-3": true,
            "map-style-toggle--expanded": expanded,
            "map-style-toggle--collapsed": !expanded
        });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: "map-style-toggle__options" }, this.options.map(function (option) {
                return React.createElement("button", { key: option, className: "btn btn-rounded-circle btn-outline-light shadow", "data-maptype": option, onClick: _this.onSelect });
            })),
            React.createElement("div", { className: "map-style-toggle__selected p-3" },
                React.createElement("button", { className: "btn btn-rounded-circle btn-outline-light shadow", "data-maptype": mapStyle, onClick: this.onToggle }))));
    };
    /**
     *
     */
    MapStyleToggle.prototype.onSelect = function (event) {
        var onChange = this.props.onChange;
        var mapStyle = event.target.dataset.maptype;
        if (onChange) {
            onChange(mapStyle);
        }
        this.setState({ mapStyle: mapStyle, expanded: false });
    };
    /**
     *
     */
    MapStyleToggle.prototype.onToggle = function () {
        this.setState({ expanded: true });
    };
    return MapStyleToggle;
}(React.Component));
MapStyleToggle.contextType = ApplicationContext;
export default injectIntl(MapStyleToggle);
